// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nAbf","rootMobile":"styles_rootMobile__oAdmF"};